import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 flex-shrink-0">
            <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
              <i className="ri-book-open-line text-white text-lg"></i>
            </div>
            <span className={`text-lg font-bold font-heading whitespace-nowrap ${scrolled || !isHome ? 'text-foreground-900' : 'text-white'}`}>
              韩漫画网
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {categories.slice(1, 7).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-3 py-2 text-sm rounded-md transition-colors duration-200 whitespace-nowrap ${
                  scrolled || !isHome
                    ? 'text-foreground-600 hover:text-primary-500 hover:bg-background-100'
                    : 'text-white/80 hover:text-white hover:bg-white/10'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <Link
              to="/about"
              className={`hidden md:flex items-center gap-1 px-4 py-2 text-sm font-medium rounded-full transition-all duration-200 whitespace-nowrap ${
                scrolled || !isHome
                  ? 'bg-primary-500 text-white hover:bg-primary-600'
                  : 'bg-white/20 text-white hover:bg-white/30 backdrop-blur-sm'
              }`}
            >
              关于我们
            </Link>

            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors ${
                scrolled || !isHome
                  ? 'text-foreground-700 hover:bg-background-100'
                  : 'text-white hover:bg-white/10'
              }`}
              aria-label="菜单"
            >
              <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden border-t border-background-200 bg-background-50 animate-fade-in">
            <div className="py-3 px-2 flex flex-col gap-1">
              {categories.slice(1).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="flex items-center gap-3 px-3 py-2.5 text-sm text-foreground-700 hover:text-primary-500 hover:bg-background-100 rounded-md transition-colors"
                >
                  <i className={`${cat.icon} w-5 h-5 flex items-center justify-center`}></i>
                  {cat.name}
                </Link>
              ))}
              <Link
                to="/about"
                className="flex items-center gap-3 px-3 py-2.5 text-sm text-foreground-700 hover:text-primary-500 hover:bg-background-100 rounded-md transition-colors mt-1 border-t border-background-200 pt-3"
              >
                <i className="ri-information-line w-5 h-5 flex items-center justify-center"></i>
                关于我们
              </Link>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}